import { createRequest } from "helpers/tools";

export const getSourcesByConnectionId = async (connection_id) => {
    return await createRequest({
        suffix: `lead/sources?filter_with_connection=${connection_id}`,
        method: "get",
        handleError: false,
    });
};
